import React from 'react';
import { StyledH2, StyledSubtitle } from '../../../Title/styles/Title.styled';
import {
    AppGalleryIcon,
    AppStoreLink,
    GooglePlayIcon,
    NashStoreIcon,
    RuStoreIcon
} from '../../../AppLinks';
import { StyledAppLinksContainer } from '../../../AppLinks/style/AppLinks.styled';
import { StyledOfferSection } from './style/OfferSection.styled';
import { StyledLink } from '../../../links/style/Link.styled';

export const OfferSection = () => {
    return (
        <StyledOfferSection>
            <StyledH2>Оформи подписку на сайте ZAYCEV.NET</StyledH2>
            <StyledSubtitle>
                Скачать Zaycev.net на свой смартфон можно со всех магазинов
                приложений. Подписка будет действовать одинаково — вне
                зависимости от того, откуда скачали приложение
            </StyledSubtitle>

            <StyledAppLinksContainer>
                <dt className="visually-hidden">
                    Магазины приложений, где можно скачать Zaycev.net
                </dt>
                <dd>
                    <AppStoreLink />
                </dd>
                <dd>
                    <AppGalleryIcon />
                </dd>
                <dd>
                    <GooglePlayIcon />
                </dd>
                <dd>
                    <NashStoreIcon />
                </dd>
                <dd>
                    <RuStoreIcon />
                </dd>
            </StyledAppLinksContainer>
            <footer>
                <mark>
                    Подписка будет распространяться на все устройства через
                    приложение и сайт – нужно только войти в аккаунт
                </mark>
                <StyledLink
                    href="https://zaycev.net/spages/useragreement.shtml#useragreement-subscription"
                    target="_blank"
                >
                    Условия подписки
                </StyledLink>
            </footer>
        </StyledOfferSection>
    );
};
